export default class Cell
{
  constructor()
  {
    this._row = 0
    this._col = 0
    this._solution = 0
    this._input = 0
    this._selected = false
  }

  get row() { return this._row }
  set row(row) { this._row = row }

  get col() { return this._col }
  set col(col) { this._col = col }

  get solution() { return this._solution }
  set solution(solution) { this._solution = solution }

  get given() { return this._given }
  set given(given) { this._given = given }

  get input() { return this._input }
  set input(input) { this._input = input }
  
  get selected() { return this._selected }
  set selected(selected) 
  { 
    if (selected === 'true')
      selected = true
    else if (selected === 'false')
      selected = false
    this._selected = Boolean(selected) 
  }

}

